import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import * as moment from 'moment';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { ToastrService } from 'ngx-toastr';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { ExportgridComponent } from '../../grid/exportgrid/exportgrid.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-customerstatementreport',
  templateUrl: './customerstatementreport.component.html',
  styleUrls: ['./customerstatementreport.component.css']
})
export class CustomerstatementreportComponent implements OnInit {

  
  @ViewChild('filterbar', { static: false }) filterbar;

  isadd: boolean = false;
  isedit: boolean = false;
  isdelete: boolean = false;
  isview: boolean = false;
  isprint: boolean = false;
  isexport: boolean = false;
  isfilter: boolean = false;


  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;


  formname: string = "CustomerReport";


  gridformtype: string = "";

  checkemp: string = "";
  companycheckColl: any = [];
  filterstatus: string = "ALL";
  salesreportColl: any = [];
  dinetypeColl: any = [];
  groupColl: any = [];
  productColl: any = [];
  shiftColl: any = [];


  fromdate: any = new Date();
  todate: any = new Date();
  filterdinetypeid: number = null;
  filtergroupid: number = null;
  filterproductid: number = null;
  filtershiftid: number = null;

  searchtxt: any = "";

  columnDefs = [
    { headerName: 'Customer', field: 'customername' },
    { headerName: 'Bill No', field: 'billno' },    
    { headerName: 'Date', field: 'salesdate', type: 'date' },    
    { headerName: 'DineType', field: 'dinetypename' },        
    { headerName: 'Sub Total', field: 'subtotal', type: 'decimal' },
    { headerName: 'Tax Amount', field: 'itemtaxamt', type: 'decimal' },
    { headerName: 'Prod. Disc.Amount', field: 'itemdiscamt', type: 'decimal' },
    { headerName: 'Charges Total', field: 'chargestotal', type: 'decimal' },
    { headerName: 'Disc.Amount', field: 'discamt', type: 'decimal' },
    { headerName: 'Round Off', field: 'roundoff', type: 'decimal' },
    { headerName: 'Grand Total', field: 'grandtotal', type: 'decimal' },
    { headerName: 'Contribution', field: 'perc', type: 'decimal' },
  ]

  gridOptions = {
    enableactioncol: false,
    columnDefs: this.columnDefs,
  };

  dateCustomClasses: DatepickerDateCustomClasses[];


  constructor(private appService: DhukanDataService, public router: Router, private productFindService: NgbModal, private datePipe: DatePipe,
    private confirmationDialogService: ConfirmationDialogService, private toastr: ToastrService, public loginService: LoginDataService) {
    this.fnServiceChanges();

    this.dateCustomClasses = [
      { date: new Date(), classes: ['bg-warning'] },
    ];
    //this.fromdate.setDate(this.fromdate.getDate() - 15);
  }

  //Company Check
  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          this.fnCheckPrivilage();
          if (this.isview) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    });
  }


  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          this.fnCheckPrivilage();
          if (this.isview) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnGetUserRoleList();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  fnOnInitForm() {
    this.fngetCustomerReport();
    // this.fngetDinetype();
    // this.fngetGroup();
    // this.fngetProduct();
    // this.fngetShift();
  }


  fnCheckPrivilage() {

    this.isadd = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE');
    this.isedit = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER');
    this.isdelete = this.loginService.fnCheckUserRoleAction(this.formname, 'DELETE');
    this.isview = this.loginService.fnCheckUserRoleAction(this.formname, 'VIEW');
    this.isprint = this.loginService.fnCheckUserRoleAction(this.formname, 'PRINT');
    this.isexport = this.loginService.fnCheckUserRoleAction(this.formname, 'EXPORT');


  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }



  fngetDinetype() {

    var data = {
      'dinetypeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getDinetype(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.dinetypeColl = res.json().result;

          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fngetGroup() {

    var data = {
      'groupid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getGroup(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.groupColl = res.json().result;

          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fngetProduct() {

    var data = {
      'productid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getProduct(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.productColl = res.json().result[0];

          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  fngetShift() {

    var data = {
      'shiftid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getShift(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.shiftColl = res.json().result;

          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  //Get
  fngetCustomerReport() {
    try {
      this.fnShowProgress()
      var data = {
        'fromdate': this.fnFormatDatetime(this.fromdate),
        'todate': this.fnFormatDatetime(this.todate),
        'companyid': this.loginService.fnGetCompanyId(),
        'groupid': this.filtergroupid,
      }

      this.appService.getSalesCustomerStatementReport(data)
        .subscribe(
          (res) => {
            this.fnHideProgress()
            if (res.json().status === 200) {
              this.salesreportColl = res.json().result;

            } else if (res.json().status === 400) {
              this.toastr.error("Error", res.json().err_field)
            }
          },
          (err) => {
            this.fnHideProgress()
            this.toastr.error('Error', err);
          })
    } catch (ex) {
      this.fnHideProgress()
      this.fnShowErrorMsg(ex)
    }
  }







  fnSetTable() {

  }

  private fnFocusTableRow(index, status) {
    if (index > -1) {
      if (status === 'IN') {
        this.salesreportColl[index].hoverfocus = "IN"
      }
      else {
        this.salesreportColl[index].hoverfocus = ""
      }
    }
  }

  fnTabHeaderClick(type) {
    this.searchtxt = "";
    this.gridformtype = type;
  }

  fnCloseForm() {
    try {
      this.router.navigate(['/Report']);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnActionExportClick() {
    const modalRef = this.productFindService.open(ExportgridComponent, { size: <any>'xxl', backdrop: 'static' });
    modalRef.componentInstance.doctype = this.formname;
    modalRef.componentInstance.columnDefs = this.columnDefs;
    modalRef.componentInstance.contentColl = this.salesreportColl;
    modalRef.componentInstance.fnSetTable();
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {


    });
  }



  fnMomentDateTimeFormatter(params) {
    if (params.value) {
      return moment(params.value).format('DD-MM-YYYY hh:mm a');//  
    }
    else {
      return '';
    }

  }
  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }
  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }



  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }

  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }











}
